export default "__VITE_ASSET__25ac9417__"